import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { GlassContainer } from './GlassContainer';
import { TSizes } from '../constants/sizes';

export const ContactCard = ({ contact }) => {
  const { title, link, media } = contact || {};

  const handleTap = () => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <GlassContainer
      clickable={true}
      radius={TSizes.radius2XL || 32}
      style={{
        width: '100%',
        padding: '20px',
        display: 'flex',
        boxSizing: 'border-box'
      }}
    >
      <div
        onClick={handleTap}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: link ? 'pointer' : 'default'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
          <div
            style={{
              width: '80px',
              height: '80px',
              borderRadius: `${TSizes.radiusLG || 16}px`,
              overflow: 'hidden',
              backgroundColor: 'transparent',
              flexShrink: 0
            }}
          >
            {media?.url && (
              <img
                src={media.url}
                alt={title || ''}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            )}
          </div>

          <span
            style={{
              color: 'var(--text-primary)',
              fontSize: '14px',
              fontWeight: '700',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1
            }}
          >
            {title}
          </span>
        </div>

        <ArrowUpRight size={18} color="#60a5fa" style={{ flexShrink: 0, marginLeft: '8px' }} />
      </div>
    </GlassContainer>
  );
};
